var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19pt",
    height: "19pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222 900 c-54 -33 -62 -68 -62 -254 0 -164 0 -166 24 -181 19 -13 29 -14 45 -5 20 10 21 19 21 175 0 135 3 166 16 179 12 13 41 16 145 16 l129 0 0 -74 c0 -41 3 -82 6 -91 11 -28 60 -45 134 -45 l70 0 0 -75 c0 -65 3 -76 21 -85 16 -9 26 -8 45 5 23 15 24 20 24 117 l0 101 -117 119 -117 118 -175 0 c-159 0 -179 -2 -209 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 399 c-8 -16 -8 -28 0 -45 l11 -24 320 0 320 0 11 24 c8 17 8 29 0 45 -12 21 -16 21 -331 21 -315 0 -319 0 -331 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 284 c-12 -8 -22 -24 -22 -34 0 -10 10 -26 22 -34 33 -24 603 -24 636 0 12 8 22 24 22 34 0 10 -10 26 -22 34 -33 24 -603 24 -636 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 149 c-8 -16 -8 -28 0 -45 l11 -24 320 0 320 0 11 24 c8 17 8 29 0 45 -12 21 -16 21 -331 21 -315 0 -319 0 -331 -21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllGigs);
export default __webpack_public_path__ + "static/media/AllGigs.3022f721.svg";
export { ForwardRef as ReactComponent };